/**
 * Javascript driven collapsing
 *
 * CSS transitions are preferable, but for a true collapsing effect we need javascript
 *
 * @param {Element} element
 */
export function collapseBySlide(element) {
  // get the height of the element's inner content, regardless of its actual size
  var sectionHeight = element.scrollHeight;

  // temporarily disable all css transitions
  var elementTransition = element.style.transition;
  element.style.transition = "";

  if (element.getAttribute("aria-hidden")) {
    element.setAttribute("aria-hidden", "true");
  }

  // on the next frame (as soon as the previous style change has taken effect),
  // explicitly set the element's height to its current pixel height, so we
  // aren't transitioning out of 'auto'
  requestAnimationFrame(function () {
    element.style.height = sectionHeight + "px";
    element.style.transition = elementTransition;

    // on the next frame (as soon as the previous style change has taken effect),
    // have the element transition to height: 0
    requestAnimationFrame(function () {
      element.style.height = "0px";
    });
  });
}

/**
 * Javascript driven expanding
 *
 * CSS transitions are preferable, but for a true collapsing effect we need javascript
 *
 * @param {Element} element
 */
export function expandBySlide(element) {
  // get the height of the element's inner content, regardless of its actual size
  const sectionHeight = element.scrollHeight;

  // have the element transition to the height of its inner content
  element.style.height = sectionHeight + "px";

  const transitionEndListener = function () {
    // remove this event listener so it only gets triggered once
    element.removeEventListener("transitionend", transitionEndListener);
    // remove "height" from the element's inline styles, so it can return to its initial value
    element.style.height = "auto";
  };

  if (element.getAttribute("aria-hidden")) {
    element.setAttribute("aria-hidden", "false");
  }

  // when the next css transition finishes (which should be the one we just triggered)
  element.addEventListener("transitionend", transitionEndListener);
}
